import api from "./index";
import { cachedApiCall, cacheKeys, invalidateCache } from "../lib/cache";

// Cache TTL: 15 minutes for settings (they don't change frequently)
const SETTINGS_CACHE_TTL = 15 * 60 * 1000;

export const fetchAdminNotificationSettings = async (options = {}) => {
  return cachedApiCall(
    cacheKeys.settingsAdminNotifications(),
    async () => {
      const response = await api.get("/notifications/admin-setting/");
      return response.data;
    },
    SETTINGS_CACHE_TTL,
    options
  );
};

export const updateAdminNotificationSettings = async (settings) => {
  const response = await api.post("/notifications/admin-setting/", settings);
  // Invalidate cache after update
  invalidateCache.settingsAdminNotifications();
  return response.data;
};

export const fetchAgentNotificationSettings = async (options = {}) => {
  return cachedApiCall(
    cacheKeys.settingsAgentNotifications(),
    async () => {
      const response = await api.get("/notifications/agent-setting/");
      return response.data;
    },
    SETTINGS_CACHE_TTL,
    options
  );
};

export const updateAgentNotificationSettings = async (settings) => {
  const response = await api.post("/notifications/agent-setting/", settings);
  // Invalidate cache after update
  invalidateCache.settingsAgentNotifications();
  return response.data;
};
